import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { handleApply } from "../../utils/handleApply";

/**
 * 一覧カード右上のメニュー（詳細・問い合わせ）project/job共通
 * @param {string|number} itemId - 対象のID
 * @param {"project"|"job"} type - アイテム種別
 * @param {string} csrfToken
 */
const IndexMenu = ({
  itemId,
  type = "project",
  csrfToken,
  contractExists,
  isActive,
}) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const detailPath = type === "job" ? `/jobs/${itemId}` : `/projects/${itemId}`;
  const applyType = type === "job" ? "jobs" : "projects";

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handleOpenMenu(e);
        }}
        size="small"
        sx={{ p: 0.5 }}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={(event) => {
          if (event?.stopPropagation) event.stopPropagation();
          handleCloseMenu();
        }}
      >
        {/* 詳細ページへ遷移 */}
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            navigate(detailPath);
          }}
        >
          詳細を見る
        </MenuItem>

        {/* 問い合わせ・応募（メール送信）、希望条件が入力済みかつエージェントに公開中のときのみ表示 */}
        {contractExists && isActive && (
          <Tooltip
            title="企業に問い合わせメールが送信されます"
            placement="bottom"
            arrow
            disableHoverListener={isMobile} // スマホではホバー無効
            disableTouchListener={isMobile} // タッチ長押しでも出さない
          >
            <MenuItem
              onClick={async (e) => {
                e.stopPropagation();
                e.preventDefault();
                await handleApply({
                  type: applyType,
                  id: itemId,
                  csrfToken,
                });
                handleCloseMenu();
              }}
            >
              詳細を聞きたい
            </MenuItem>
          </Tooltip>
        )}
      </Menu>
    </>
  );
};

export default IndexMenu;
